import React from "react";
import "./index.css";

const AnimatedCheckbox = ({ isChecked, onChange, label, className }) => {
    return (
        <div className={`checkbox-container ${className} mt30`}>
            <label className="checkbox-label">
                <input
                    type="checkbox"
                    checked={isChecked}
                    onChange={onChange}
                />
                <span className={`checkbox-custom ${isChecked ? "checked" : ""}`}>
                    {isChecked && <span className="checkmark">✔</span>}
                </span>
                {label && <span className="checkbox-text">{label}</span>}
            </label>
        </div>
    );
};

export default AnimatedCheckbox;
